import {Schema, String, filter} from 'effect/Schema';

export const AccountNumber = String.pipe(
    filter(value => /^\d{7,25}$/.test(value), {
        identifier: 'AccountNumber',
    })
) as unknown as Schema<AccountNumber>;
export type AccountNumber = import('../src/AccountNumber').AccountNumber;
